export default __webpack_public_path__ + "static/harmonious-carousel-mobile-panel4-2c1b35cfad37bb62f682b41b0c959fcbeb304207764a145679f5b56e52fbbf54.png";